import {
  validatePAN,
  validateGST,
  validateMobile,
  validateEmail,
  validateIFSC,
  validateAccountNumber
} from '../../../../utils/validationUtils';
import DropDown from '../../../../components/DropDown';
import { fetchPincodeDetailsAction } from '../../../../actions/pincodeAction';
import { useEffect } from 'react';

export const clientFormFields = [
  // Entity Information Section
  {
    name: "entityCategory",
    label: "entity Category",
    type: "select",
    placeholder: "Select entity category",
    required: true,
    section: "entityInfo",
    options: [
      { value: "", label: "Select entity category" },
      { value: "client", label: "Client" },
      { value: "vendor", label: "Vendor" },
    ],
  },
  {
    name: "entityLOBType",
    label: "Entity LOB Type",
    type: "select",
    placeholder: "Select entity LOB type",
    required: true,
    section: "entityInfo",
    options: [
      { value: "", label: "Select entity LOB type" },
      { value: "travel", label: "Travel" },
      { value: "company", label: "Company" },
      { value: "auto", label: "Auto" },
      { value: "gadget", label: "Gadget" },
    ],
  },
  {
    name: "selectedlobtypenationality",
    label: "Selected LOB Type Nationality",
    type: "select",
    placeholder: "Select selected LOB type nationality",
    required: false,
    section: "entityInfo",
    conditionalOn: "entityLOBType",
    conditionalValue: "travel",
    options: [
      { value: "", label: "Select selected LOB type nationality" },
      { value: "Domestic", label: "Domestic" },
      { value: "international", label: "International" },
    ],
  },
  {
    name: "sectionEntityInfo",
    type: "section",
    label: "Entity Information",
  },
  {
    name: "entityName",
    label: "Entity Name",
    type: "text",
    placeholder: "Enter entity name",
    required: true,
    section: "entityInfo",
  },
  {
    name: "State",
    label: "State",
    type: "text",
    placeholder: "Enter state name ",
    required: true,
    rows: 3,
    section: "entityInfo",
  },
  {
    name: "city",
    label: "city",
    type: "text",
    placeholder: "Enter City Name",
    required: true,
    rows: 3,
    section: "entityInfo",
  },
  {
    name: "pinCode",
    label: "Pin Code",
    type: "text",
    placeholder: "Enter 6-digit pin code",
    required: true,
    maxLength: 6,
    section: "entityInfo",
  },
  {
    name: "address",
    label: "Address",
    type: "textarea",
    placeholder: "Enter complete address (building number, street, landmark...)",
    required: false,
    maxLength: 6,
    section: "entityInfo",
  },
  {
    name: "aaDepartmentFunction",
    label: "AA - Department Function",
    type: "select",
    placeholder: "Select department function",
    required: true,
    section: "entityInfo",
    options: [
      { value: "", label: "Select department function" },
      { value: "finance", label: "Finance" },
      { value: "operations", label: "Operations" },
      { value: "hr", label: "Human Resources" },
      { value: "it", label: "Information Technology" },
      { value: "sales", label: "Sales" },
      { value: "marketing", label: "Marketing" },
    ],
  },
  {
    name: "natureOfBusiness",
    label: "Nature of Business",
    type: "text",
    placeholder: "Enter nature of business",
    required: true,
    section: "entityInfo",
  },
  {
    name: "entityType",
    label: "Entity Type",
    type: "select",
    placeholder: "Select entity type",
    required: true,
    section: "entityInfo",
    options: [
      { value: "", label: "Select entity type" },
      { value: "proprietorship", label: "Proprietorship" },
      { value: "partnership", label: "Partnership" },
      { value: "llp", label: "Limited Liability Partnership (LLP)" },
      { value: "private_limited", label: "Private Limited Company" },
      { value: "public_limited", label: "Public Limited Company" },
      { value: "trust", label: "Trust" },
      { value: "society", label: "Society" },
    ],
  },
  {
    name: "panNumber",
    label: "Individual PAN Number",
    type: "text",
    placeholder: "Enter Individual PAN number (e.g., ABCDE1234F)",
    required: false,
    section: "entityInfo",
    maxLength: 10,
    validation: validatePAN,
  },
  {
    name: "CompanypanNumber",
    label: "Company PAN Number",
    type: "text",
    placeholder: "Enter Company PAN number (e.g., ABCDE1234F)",
    required: true,
    section: "entityInfo",
    maxLength: 10,
    validation: validatePAN,
  },

  // Upload Entity Related Documents
  // {
  //     name: 'sectionEntityDocs',
  //     type: 'section',
  //     label: 'Upload Entity Related Documents'
  // },
  // {
  //     name: 'certificateOfIncorporation',
  //     label: 'Certificate of Incorporation / Registration Certificate',
  //     type: 'file',
  //     placeholder: 'Upload certificate',
  //     required: true,
  //     section: 'entityDocs',
  //     accept: '.pdf,.jpg,.jpeg,.png',
  //     multiple: true,
  //     maxFiles: 10,
  //     maxSize: 10485760, // 10MB in bytes
  //     helpText: 'File limit: 10 files, Max size: 10MB per file, Allowed: PDF, Image'
  // },
  // {
  //     name: 'panDocument',
  //     label: 'PAN',
  //     type: 'file',
  //     placeholder: 'Upload PAN document',
  //     required: true,
  //     section: 'entityDocs',
  //     accept: '.pdf,.jpg,.jpeg,.png',
  //     multiple: true,
  //     maxFiles: 10,
  //     maxSize: 10485760,
  //     helpText: 'File limit: 10 files, Max size: 10MB per file, Allowed: PDF, Image'
  // },
  // {
  //     name: 'addressProof',
  //     label: 'Address Proof',
  //     type: 'file',
  //     placeholder: 'Upload address proof',
  //     required: true,
  //     section: 'entityDocs',
  //     accept: '.pdf,.jpg,.jpeg,.png',
  //     multiple: true,
  //     maxFiles: 10,
  //     maxSize: 10485760,
  //     helpText: 'File limit: 10 files, Max size: 10MB per file, Allowed: PDF, Image'
  // },

  // Proprietor / Director KYC
  // {
  //     name: 'sectionDirectorKYC',
  //     type: 'section',
  //     label: 'Proprietor / Director KYC'
  // },
  // {
  //     name: 'directorKYC',
  //     label: 'PAN and Address Proof',
  //     type: 'file',
  //     placeholder: 'Upload director KYC documents',
  //     required: true,
  //     section: 'directorKYC',
  //     accept: '.pdf,.jpg,.jpeg,.png',
  //     multiple: true,
  //     maxFiles: 10,
  //     maxSize: 10485760,
  //     helpText: 'File limit: 10 files, Max size: 10MB per file, Allowed: PDF, Image'
  // },

  // GST Information
  {
    name: "sectionGST",
    type: "section",
    label: "GST Information",
  },
  {
    name: "isGSTRegistered",
    label: "Whether GST Registered?",
    type: "select",
    placeholder: "Select option",
    required: true,
    section: "gst",
    options: [
      { value: "", label: "Select option" },
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  {
    name: "gstNumberPrimary",
    label: "GST Number - Primary (used for Billing)",
    type: "text",
    placeholder: "Enter primary GST number (e.g., 22AAAAA0000A1Z5)",
    required: true,
    section: "gst",
    conditionalOn: "isGSTRegistered",
    conditionalValue: "yes",
    maxLength: 15,
    validation: validateGST,
  },
  {
    name: "gstAddress",
    label: "Registered GST Address",
    type: "textarea",
    placeholder: "Enter the registered GST address including building number, street, area, city, state, and pincode",
    required: false,
    section: "gst",
    conditionalOn: "isGSTRegistered",
    conditionalValue: "yes",
    rows: 3,
  },
  // {
  //     name: 'gstCertificates',
  //     label: 'GST Certificate(s)',
  //     type: 'file',
  //     placeholder: 'Upload GST certificates',
  //     required: false,
  //     section: 'gst',
  //     conditionalOn: 'isGSTRegistered',
  //     conditionalValue: 'yes',
  //     accept: '.pdf,.jpg,.jpeg,.png',
  //     multiple: true,
  //     maxFiles: 10,
  //     maxSize: 10485760,
  //     helpText: 'Upload multiple certificates if applicable. File limit: 10 files, Max size: 10MB per file'
  // },

  // MSME Information
  {
    name: "sectionMSME",
    type: "section",
    label: "MSME Information",
  },
  {
    name: "isMSMERegistered",
    label: "Whether registered under MSME?",
    type: "select",
    placeholder: "Select option",
    required: true,
    section: "msme",
    options: [
      { value: "", label: "Select  option" },
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  // {
  //     name: 'msmeDocument',
  //     label: 'MSME Certificate',
  //     type: 'file',
  //     placeholder: 'Upload MSME certificate',
  //     required: false,
  //     section: 'msme',
  //     conditionalOn: 'isMSMERegistered',
  //     conditionalValue: 'yes',
  //     accept: '.pdf,.jpg,.jpeg,.png',
  //     multiple: true,
  //     maxFiles: 10,
  //     maxSize: 10485760,
  //     helpText: 'File limit: 10 files, Max size: 10MB per file, Allowed: PDF, Image'
  // },

  // Contact Person Details
  {
    name: "sectionContactPerson",
    type: "section",
    label: "Contact Person Details",
  },
  {
    name: "contactPersonName",
    label: "Contact Person Name",
    type: "text",
    placeholder: "Enter contact person name",
    required: true,
    section: "contactPerson",
  },
  {
    name: "contactPersonDesignation",
    label: "Designation",
    type: "text",
    placeholder: "Enter designation",
    required: true,
    section: "contactPerson",
  },
  {
    name: "contactPersonMobile",
    label: "Mobile Number",
    type: "tel",
    placeholder: "Enter 10-digit mobile number",
    required: true,
    section: "contactPerson",
    maxLength: 10,
    validation: validateMobile,
  },
  {
    name: "contactPersonEmail",
    label: "E-mail address (Will be used for communication)",
    type: "email",
    placeholder: "Enter email address (e.g., user@example.com)",
    required: true,
    section: "contactPerson",
    validation: validateEmail,
  },

  // Bank Details
  {
    name: "sectionBankDetails",
    type: "section",
    label: "Bank Details",
  },
  {
    name: "hasBankDetails",
    label: "Provide Bank Details?",
    type: "radio",
    placeholder: "Select option",
    required: true,
    section: "bankDetails",
    options: [
      { value: "", label: "Select option" },
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
  {
    name: "bankName",
    label: "Bank Name",
    type: "text",
    placeholder: "Enter bank name",
    required: true,
    section: "bankDetails",
    conditionalOn: "hasBankDetails",
    conditionalValue: "yes",
  },
  {
    name: "accountNumber",
    label: "Account Number",
    type: "text",
    placeholder: "Enter account number",
    required: true,
    section: "bankDetails",
    conditionalOn: "hasBankDetails",
    conditionalValue: "yes",
    validation: validateAccountNumber,
  },
  {
    name: "ifscCode",
    label: "IFSC Code",
    type: "text",
    placeholder: "Enter IFSC code (e.g., SBIN0001234)",
    required: true,
    section: "bankDetails",
    conditionalOn: "hasBankDetails",
    conditionalValue: "yes",
    maxLength: 11,
    validation: validateIFSC,
  },
  {
    name: "accountType",
    label: "Account Type",
    type: "select",
    placeholder: "Select account type",
    required: false,
    section: "bankDetails",
    conditionalOn: "hasBankDetails",
    conditionalValue: "yes",
    options: [
      { value: "", label: "Select account type" },
      { value: "savings", label: "Savings" },
      { value: "current", label: "Current" },
    ],
  },
  {
    name: "branchName",
    label: "Branch Name",
    type: "text",
    placeholder: "Enter branch name",
    required: true,
    section: "bankDetails",
    conditionalOn: "hasBankDetails",
    conditionalValue: "yes",
  },
  // {
  //     name: 'cancelledCheque',
  //     label: 'Cancelled Cheque / Bank Statement',
  //     type: 'file',
  //     placeholder: 'Upload cancelled cheque or bank statement',
  //     required: false,
  //     section: 'bankDetails',
  //     conditionalOn: 'hasBankDetails',
  //     conditionalValue: 'yes',
  //     accept: '.pdf,.jpg,.jpeg,.png',
  //     multiple: true,
  //     maxFiles: 10,
  //     maxSize: 10485760,
  //     helpText: 'File limit: 10 files, Max size: 10MB per file, Allowed: PDF, Image'
  // }
];

export const initialClientState = {
  // Entity Category and LOB
  entityCategory: "",
  entityLOBType: "",
  selectedlobtypenationality: "",
  // Entity Information
  entityName: "",
  address: "",
  pinCode: "",
  city: "",
  State: "",
  aaDepartmentFunction: "",
  natureOfBusiness: "",
  entityType: "",
  panNumber: "",

  // Entity Documents
  // certificateOfIncorporation: [],
  // panDocument: [],
  // addressProof: [],

  // Director KYC
  // directorKYC: [],

  // GST Information
  isGSTRegistered: "",
  gstNumberPrimary: "",
  gstNumbersOther: "",
  // gstCertificates: [],

  // MSME Information
  isMSMERegistered: "",
  // msmeDocument: [],

  // Contact Person
  contactPersonName: "",
  contactPersonDesignation: "",
  contactPersonMobile: "",
  contactPersonEmail: "",

  // Bank Details
  hasBankDetails: "",
  bankName: "",
  accountNumber: "",
  ifscCode: "",
  accountType: "",
  branchName: "",
  // cancelledCheque: []
};

// Add email receipt checkbox at the end
clientFormFields.push(
  {
    name: "sectionEmailReceipt",
    type: "section",
    label: "Email Notification",
  },
  {
    name: "sendEmailReceipt",
    label: "Send an email receipt for this response",
    type: "checkbox",
    required: false,
    section: "emailReceipt",
    helpText:
      "You will receive a confirmation email with the submitted details",
  },
);

// Add to initial state
initialClientState.sendEmailReceipt = false;

/**
 * Live validation function for individual fields
 */
const validateField = (fieldName, value, formData) => {
  const field = clientFormFields.find(f => f.name === fieldName);

  if (!field || field.type === 'section') return null;

  // Check if field should be shown based on conditional logic
  if (field.conditionalOn) {
    const conditionalValue = formData[field.conditionalOn];
    if (conditionalValue !== field.conditionalValue) {
      return null; // Field is hidden, no validation needed
    }
  }

  // Don't validate empty optional fields
  if (!field.required && (!value || value.trim() === '')) {
    return null;
  }

  // Check required validation
  if (field.required && (!value || value.trim() === '')) {
    return `${field.label} is required`;
  }

  // Check custom validation if value exists and field has validation
  if (field.validation && value && value.trim() !== '') {
    const validationResult = field.validation(value);
    if (validationResult !== true) {
      return validationResult;
    }
  }

  return null; // No error
};

export const useClientForm = (formData, errors, onChange, onChangeMultiple, onBlur, onSubmit, setErrors, isSubmitting) => {
  const validateForm = () => {
    const newErrors = {};

    clientFormFields.forEach((field) => {
      if (field.type === 'section') return;

      if (field.conditionalOn) {
        const conditionalValue = formData[field.conditionalOn];
        if (conditionalValue !== field.conditionalValue) {
          return;
        }
      }

      const value = formData[field.name];

      if (field.required && (!value || (Array.isArray(value) && value.length === 0))) {
        newErrors[field.name] = `${field.label} is required`;
      } else if (field.validation && value && !Array.isArray(value)) {
        const validationResult = field.validation(value);
        if (validationResult !== true) {
          newErrors[field.name] = validationResult;
        }
      }
    });

    return newErrors;
  };

  // pinCode reaches exactly 6 digits
  useEffect(() => {
    const pinCode = formData.pinCode || '';
    if (pinCode.length !== 6) {
      if (pinCode.length > 0) {
        onChangeMultiple({ city: '', State: '' });
      }
      return;
    }

    fetchPincodeDetailsAction(pinCode).then((result) => {
      if (result.success) {
        onChangeMultiple({ city: result.city, State: result.state });
        setErrors(prev => { const e = { ...prev }; delete e.pinCode; return e; });
      } else {
        onChangeMultiple({ city: '', State: '' });
        setErrors(prev => ({ ...prev, pinCode: result.error }));
      }
    });
  }, [formData.pinCode]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    onSubmit(formData);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    let newValue = type === 'checkbox' ? checked : value;

    // Auto-uppercase for specific fields
    const uppercaseFields = ['panNumber', 'gstNumberPrimary', 'ifscCode'];
    if (uppercaseFields.includes(name) && typeof newValue === 'string') {
      newValue = newValue.toUpperCase();
    }

    // Only allow numbers for mobile number and account number fields
    if ((name === 'contactPersonMobile' || name === 'accountNumber') && typeof newValue === 'string') {
      newValue = newValue.replace(/\D/g, '');
    }

    // Pincode — handle separately before the generic onChange
    // TODO: re-enable validation after debugging
    if (name === 'pinCode') {
      const digits = newValue.replace(/\D/g, '').slice(0, 6);
      onChange(name, digits);
      return;
    }

    // If hasBankDetails toggled to "no", clear bank field errors
    if (name === 'hasBankDetails' && newValue === 'no') {
      const bankFields = ['bankName', 'accountNumber', 'ifscCode', 'accountType', 'branchName'];
      setErrors(prev => {
        const e = { ...prev };
        bankFields.forEach(f => delete e[f]);
        return e;
      });
    }

    // Generic update for all other fields
    onChange(name, newValue);

    // Clear error when user starts typing
    if (type !== 'checkbox' && errors[name]) {
      setErrors(prevErrors => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    // Call the onBlur function passed from FormsData for mobile number validation
    if (onBlur) {
      onBlur(name, value);
    }
  };

  const handleFileChange = (e, fieldName) => {
    const files = Array.from(e.target.files);
    const field = clientFormFields.find(f => f.name === fieldName);

    if (field.maxFiles && files.length > field.maxFiles) {
      setErrors({
        ...errors,
        [fieldName]: `Maximum ${field.maxFiles} files allowed`
      });
      return;
    }

    const oversizedFiles = files.filter(file => file.size > field.maxSize);
    if (oversizedFiles.length > 0) {
      setErrors({
        ...errors,
        [fieldName]: `File size must not exceed ${field.maxSize / 1048576}MB`
      });
      return;
    }

    onChange(fieldName, files);
  };

  const shouldShowField = (field) => {
    if (!field.conditionalOn) return true;
    return formData[field.conditionalOn] === field.conditionalValue;
  };

  const getFieldClassName = (field) => {
    const classes = ['form-group'];

    if (field.type === 'file' || field.type === 'textarea') {
      classes.push('full-width');
    }

    if (field.type === 'file') {
      classes.push('form-group-file');
    }

    return classes.join(' ');
  };

  const renderField = (field) => {
    if (!shouldShowField(field)) return null;

    const value = formData[field.name] || '';
    const error = errors[field.name];
    const hasValue = value && value.toString().trim() !== '';

    // Check if field is valid: has value, no error, and has validation function
    const isValid = hasValue && !error && field.validation;

    if (field.type === 'section') {
      return (
        <div key={field.name} className="form-section-header">
          <h3>{field.label}</h3>
        </div>
      );
    }

    if (field.type === 'file') {
      return (
        <div key={field.name} className={getFieldClassName(field)}>
          <label htmlFor={field.name}>
            {field.label}
            {field.required && <span className="required">*</span>}
          </label>
          <div className="file-upload-wrapper">
            <input
              type="file"
              id={field.name}
              name={field.name}
              onChange={(e) => handleFileChange(e, field.name)}
              accept={field.accept}
              multiple={field.multiple}
              className={error ? 'error' : ''}
              disabled={isSubmitting}
            />
            <div className="file-upload-info">
              {field.helpText && <small className="help-text">{field.helpText}</small>}
              {Array.isArray(value) && value.length > 0 && (
                <div className="selected-files">
                  <strong>Selected files ({value.length}):</strong>
                  <ul>
                    {value.map((file, idx) => (
                      <li key={idx}>{file.name} ({(file.size / 1024).toFixed(2)} KB)</li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
          {error && <span className="error-message">{error}</span>}
        </div>
      );
    }

    if (field.type === 'textarea') {
      return (
        <div key={field.name} className={getFieldClassName(field)}>
          <label htmlFor={field.name}>
            {field.label}
            {field.required && <span className="required">*</span>}
          </label>
          <textarea
            id={field.name}
            name={field.name}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={field.placeholder}
            rows={field.rows || 3}
            className={error ? 'error' : ''}
            disabled={isSubmitting}
          />
          {error && <span className="error-message">{error}</span>}
        </div>
      );
    }

    if (field.type === 'select') {
      return (
        <div key={field.name} className={getFieldClassName(field)}>
          <label htmlFor={field.name}>
            {field.label}
            {field.required && <span className="required">*</span>}
          </label>
          <DropDown
            id={field.name}
            name={field.name}
            value={value}
            onChange={handleChange}
            // label={field.label}
            // placeholder={field.placeholder}
            options={field.options}
            error={error}
            required={field.required}
            disabled={isSubmitting}
            fullWidth
          />
        </div>
      );
    }

    if (field.type === 'checkbox') {
      return (
        <div key={field.name} className="form-group form-group-checkbox full-width">
          <label className="checkbox-label">
            <input
              type="checkbox"
              id={field.name}
              name={field.name}
              checked={value || false}
              onChange={handleChange}
              disabled={isSubmitting}
            />
            <span className="checkbox-text">
              {field.label}
              {field.required && <span className="required">*</span>}
            </span>
          </label>
          {field.helpText && <small className="help-text">{field.helpText}</small>}
          {error && <span className="error-message">{error}</span>}
        </div>
      );
    }
    if (field.type === "radio") {
      return (
        <div key={field.name} className="form-group full-width">
          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
            <label style={{ marginRight: "10px" }}>
              {field.label}
              {field.required && <span className="required">*</span>}
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <input
                type="radio"
                name={field.name}
                value="yes"
                checked={value === "yes"}
                onChange={handleChange}
              />
              Yes
            </label>
            <label style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <input
                type="radio"
                name={field.name}
                value="no"
                checked={value === "no"}
                onChange={handleChange}
              />
              No
            </label>
          </div>
          {error && <span className="error-message">{error}</span>}
        </div>
      );
    }

    // Only city and State are readonly (auto-filled from pincode lookup)
    const readonlyFields = ['city', 'State'];
    const isReadonly = readonlyFields.includes(field.name);

    return (
      <div key={field.name} className={getFieldClassName(field)}>
        <label htmlFor={field.name}>
          {field.label}
          {field.required && <span className="required">*</span>}
        </label>
        <input
          type={field.type}
          id={field.name}
          name={field.name}
          value={value}
          onChange={isReadonly ? undefined : handleChange}
          onBlur={isReadonly ? undefined : handleBlur}
          placeholder={isReadonly ? 'Auto-filled from pincode' : field.placeholder}
          className={[error ? 'error' : isValid ? 'success' : '', isReadonly ? 'readonly-field' : ''].join(' ').trim()}
          disabled={isSubmitting}
          readOnly={isReadonly}
          maxLength={field.maxLength}
        />
        {error && <span className="error-message">{error}</span>}
      </div>
    );
  };

  return {
    handleSubmit,
    renderField,
    handleBlur,
  };
};